import React from "react";
import { CardBody } from "reactstrap";
import SectionLabel from "../common/sectionLabel";

const EmptyLeftSidebarComponent = () => {
  return (
    <CardBody>
      <SectionLabel
        label="Click the section you want to start updating."
        subtitle={
          <span>
            You can also change the page you're editing by selecting it in the
            dropdown above.
            <br />
            <br /> Any doubts? Click the link below to see a video guide!
          </span>
        }
      />
    </CardBody>
  );
};

export default EmptyLeftSidebarComponent;
